/* unplugin-vue-components disabled */import script from "./RightSideBarContent.vue?vue&type=script&setup=true&lang=js"
export * from "./RightSideBarContent.vue?vue&type=script&setup=true&lang=js"

import "./RightSideBarContent.vue?vue&type=style&index=0&id=8df40c66&lang=scss"

const __exports__ = script;

export default __exports__